import styled from 'styled-components'
import { colors, getFontStyle } from '@diversioteam/diversio-ds'

import type { IBannerContainerProps, IBannerButtonProps } from './GlobalOnboardingBanner.types'

export const BannerContainer = styled.div<IBannerContainerProps>`
    background: ${colors.primaryWhite};
    border: 1px solid ${(p) => (p.$variant === 'success' ? colors.green40 : colors.primary30)};
    border-radius: 12px;
    padding: 1rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    margin-top: 0;
    margin-bottom: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.2s ease;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        padding: 1rem;
        gap: 1rem;
    }
`

export const BannerContent = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }
`

export const IconWrapper = styled.div<IBannerContainerProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background: ${(p) => (p.$variant === 'success' ? colors.green10 : colors.primary10)};
    color: ${(p) => (p.$variant === 'success' ? colors.green60 : colors.primary60)};
    flex-shrink: 0;

    svg {
        stroke-width: 2.5;
    }

    @media (max-width: 768px) {
        display: none;
    }
`

export const BannerText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    @media (max-width: 768px) {
        gap: 0.125rem;
    }
`

export const BannerTitle = styled.strong`
    ${getFontStyle('p01Semibold')}
    color: ${colors.primary90};
    display: block;
`

export const BannerDescription = styled.span`
    ${getFontStyle('p02Regular')}
    color: ${colors.primary70};
    display: block;
`

export const BannerActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-shrink: 0;

    @media (max-width: 768px) {
        width: 100%;
        gap: 0.5rem;
    }
`

export const PrimaryButton = styled.a<IBannerButtonProps>`
    ${getFontStyle('p02Semibold')}
    background: ${(p) => (p.$variant === 'success' ? colors.green60 : colors.primary60)};
    color: ${colors.primaryWhite};
    padding: 0.625rem 1.25rem;
    border-radius: 8px;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border: none;

    &:hover {
        background: ${(p) => (p.$variant === 'success' ? colors.green70 : colors.primary70)};
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:active {
        transform: translateY(0);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 768px) {
        flex: 1;
        padding: 0.75rem 1rem;
    }
`

export const SecondaryButton = styled.button`
    ${getFontStyle('p02Medium')}
    background: transparent;
    color: ${colors.primary70};
    padding: 0.625rem 1rem;
    border-radius: 8px;
    border: 1px solid ${colors.secondary200};
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        background: ${colors.primaryGray1};
        border-color: ${colors.secondary300};
        color: ${colors.primary80};
    }

    &:active {
        background: ${colors.primaryGray2};
    }

    @media (max-width: 768px) {
        flex: 1;
        padding: 0.75rem 1rem;
    }
`
